module.exports = __webpack_public_path__ + "img/chev-right.ca243557.svg";